import { addDays } from "date-fns";
import type { CommunityMemberSubscription } from "@circle-react/types/CommunityMemberSubscription";
import { PLATFORMS } from "./communityHelpers";

export const STATUS = Object.freeze({
  INCOMPLETE: "incomplete",
  ACTIVE: "active",
  TRIAL: "trial",
  PAST_DUE: "past_due",
  CANCELED: "canceled",
});

const PAYWALL_PRICE_STATUS = Object.freeze({
  SUBSCRIPTION: "subscription",
  ONETIME: "onetime",
  INSTALLMENTS: "installments",
});

export const isTrial = (subscription?: CommunityMemberSubscription): boolean =>
  subscription?.status === STATUS.TRIAL;

export const isPastDue = (
  subscription?: CommunityMemberSubscription,
): boolean => subscription?.status === STATUS.PAST_DUE;

export const hasInstallmentPricing = (
  subscription?: CommunityMemberSubscription,
): boolean =>
  subscription?.paywall_price?.price_type === PAYWALL_PRICE_STATUS.INSTALLMENTS;

export const hasSubscriptionPricing = (
  subscription?: CommunityMemberSubscription,
): boolean =>
  subscription?.paywall_price?.price_type === PAYWALL_PRICE_STATUS.SUBSCRIPTION;

export const hasOnetimePricing = (
  subscription?: CommunityMemberSubscription,
): boolean =>
  subscription?.paywall_price?.price_type === PAYWALL_PRICE_STATUS.ONETIME;

export const isSubscriptionCanceled = (
  subscription?: CommunityMemberSubscription,
): boolean => subscription?.status === STATUS.CANCELED;

export const SEARCHABLE_STATUS = [
  STATUS.ACTIVE,
  STATUS.TRIAL,
  STATUS.PAST_DUE,
  STATUS.CANCELED,
];

export const ACTIVE_STATUS = [STATUS.ACTIVE, STATUS.TRIAL, STATUS.PAST_DUE];

export const calculateTrialDaysEndsDate = (
  trialDaysParam: string | number,
  date: Date = new Date(),
): Date => {
  const trialDays = Number(trialDaysParam) > 0 ? Number(trialDaysParam) : 0;
  return addDays(date, trialDays);
};

export const doesBelongToMobilePlatform = (
  subscription?: CommunityMemberSubscription,
): boolean => {
  if (!subscription?.platform) return false;
  return (
    subscription.platform === PLATFORMS.APP_STORE ||
    subscription.platform === PLATFORMS.PLAY_STORE
  );
};
